class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.isOpen = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector("form.search");
    form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
    this.predictiveSearchResults.addEventListener(
      "click",
      this.handleBtnsClick.bind(this)
    );
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  handleBtnsClick(event) {
    let classContent = event.target.classList;
    if (classContent && classContent.contains("male_btn"))
      this.onFormSubmit(event, "male");
    if (classContent && classContent.contains("female_btn"))
      this.onFormSubmit(event, "female");
    if (event.target.closest('button[data-fullsearch]')) {
      const term = event.target.closest('button[data-fullsearch]').dataset.fullsearch;
      window.location.href = `/search?q=${encodeURIComponent(term)}`;
    }

  }

  onFormSubmit(event, type = "all") {
    event.preventDefault();
    const searchTerm = this.getQuery();
    const redirectUrl = this.findRedirect(searchTerm);

    setTimeout(() => {
      if (redirectUrl && type === "all") {
        window.location.href = redirectUrl;
      } else {
        let parameters = "";
        if (type === "male") parameters = "&filter.p.m.custom.geschlecht=Herren";
        else if (type === "female") parameters = "&filter.p.m.custom.geschlecht=Damen";

        window.location.href = `${window.Shopify.routes.root}search?q=${searchTerm}${parameters}`;
      }
    }, 10);
  }

  onFocus() {
    this.closeAllOpenFacetsFilters();
    const searchTerm = this.getQuery();
    if (!searchTerm.length) return;

    if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll("li");
    let activeElement = this.querySelector("li");

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button'
    );
    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey], true);
      return;
    }

    if (window.nostoLoadingSearch) {
      this.getNostoSearchResults(searchTerm, queryKey);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&resources[type]=product&resources[limit]=4&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          this.close();
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  getNostoSearchResults(searchTerm, queryKey) {
    nostojs(async (api) => {
      try {
        api.recordSearchSubmit(searchTerm);

        const response = await api.search(
          {
            query: searchTerm,
            products: {
              facets: ['*'],
              fields: ['productId', 'name', 'url', 'imageUrl', 'price'],
              size: 4,
              from: 0,
            },
            keywords: {
              size: 5, // fetch top keyword suggestions
            },
          },
          { track: 'autocomplete', redirect: true, isKeyword: true }
        );

        const products = response.products?.hits || [];
        const keywords = response.keywords?.hits || [];

        if (!products.length && !keywords.length) {
          this.renderSearchResults(
            '<div class="px-4 py-2 text-sm">No results</div>',
            true
          );
          return;
        }

        // --- KEYWORDS ---
        console.log(keywords, 'keywords')
        const keywordHTML = keywords
          .map(
            (kw) => `
          <li class="predictive-search__list-item" role="option" aria-selected="false">
            <button type="button" 
              class="predictive-search__item link link--text" 
              data-fullsearch="${kw.keyword}">
              ${kw._highlight?.keyword
                ? kw._highlight.keyword
                : kw.keyword
              }
            </button>
          </li>`
          )
          .join('');

        // --- PRODUCTS ---
        const productHTML = products
          .map((product) => {
            const price = product.price?.value || '';
            const currency = product.price?.currency || '';
            const image = product.imageUrl
              ? `<img src="${getResizedImageUrlPredictive(
                product.imageUrl
              )}" alt="${product.name}" class="predictive-search__image" width="50" height="62.5" />`
              : '';

            return `
            <li id="predictive-nosto-${product.productId}" 
                class="flex gap-3 items-center p-2 hover:bg-gray-100 cursor-pointer" 
                role="option" aria-selected="false">
              <a href="${product.url}" 
                class="predictive-search__item predictive-search__item--link link link--text"
                data-nosto-product-id="${product.productId}"
                data-nosto-search-term="${searchTerm}">
                ${image}
                <div class="predictive-search__item-content predictive-search__item-content--centered">
                  <h3 class="predictive-search__item-heading h5">${product.name}</h3>
                </div>
                <div class="text-gray-500">${price} ${currency}</div>
              </a>
            </li>`;
          })
          .join('');

        // --- "See all results" button ---
        const searchBtnHTML = `
        <li id="predictive-search-option-search-keywords" class="predictive-search__list-item" role="option" aria-selected="false">
          <button type="button" class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" tabindex="-1" data-fullsearch="${searchTerm}">
            ${window.search_for_text.replace('{{ terms }}', searchTerm)}
            <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
            </svg>
          </button>
        </li>`;

        // --- COMBINE ---
        const wrapper = `
        <ul id="predictive-search-results-list" role="listbox" class="predictive-search__results-list list-unstyled">
          ${keywords.length ? `${keywordHTML}` : ''}
          ${products.length ? `<li><strong class="predictive-search__item link link--text">Products</strong></li>${productHTML}` : ''}
          ${searchBtnHTML}
        </ul>
      `;

        this.cachedResults[queryKey] = wrapper;
        this.renderSearchResults(wrapper, true);

        // --- EVENT TRACKING ---
        setTimeout(() => {
          // Track product clicks
          document.querySelectorAll('[data-nosto-product-id]').forEach((el) => {
            el.addEventListener('click', () => {
              const productId = el.getAttribute('data-nosto-product-id');
              const term = el.getAttribute('data-nosto-search-term');
              nostojs((api) => {
                api.recordSearchClick(productId, term);
              });
            });
          });

          // Track keyword clicks + "See all results"
          document.querySelectorAll('[data-fullsearch]').forEach((btn) => {
            btn.addEventListener('click', () => {
              const term = btn.getAttribute('data-fullsearch');
              nostojs((api) => {
                api.recordSearchSubmit(term);
              });
            });
          });
        }, 0);
      } catch (err) {
        console.error('Nosto autocomplete error', err);
        this.renderSearchResults(
          '<div class="px-4 py-2 text-sm text-red-600">Error loading results</div>',
          true
        );
      }
    });
  }


  renderSearchResults(resultsMarkup, isRaw = false) {
    this.predictiveSearchResults.innerHTML = isRaw ? resultsMarkup : resultsMarkup;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    const resultText = this.querySelector("[data-predictive-search-live-region-count-value]")?.textContent || '';
    this.setLiveRegionText(resultText);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document.getElementById("shopify-section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.closeAllOpenFacetsFilters();
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }

    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");

    this.isOpen = false;
  }

  closeAllOpenFacetsFilters() {
    const summaryElements = document.querySelectorAll(".facets__wrapper details");
    summaryElements.forEach((summary) => {
      if (summary.hasAttribute("open")) {
        summary.removeAttribute("open");
      }
    });
  }

  findRedirect(searchTerm) {
    for (const category in searchRedirects) {
      const redirects = searchRedirects[category];
      if (redirects) {
        for (const redirectObj of redirects) {
          if (redirectObj && redirectObj.Keyword === searchTerm) {
            return redirectObj.Redirect;
          }
        }
      }
    }
    return null;
  }
}

customElements.define("predictive-search", PredictiveSearch);

// Resize helper (used in Nosto rendering)
const getResizedImageUrlPredictive = (url) => {
  const regex = /(\.[a-zA-Z0-9]+)(\?v=\d+)?$/;
  return url.replace(regex, (match, ext, version) => {
    return `_400x${ext}${version || ''}`;
  });
};
